module.exports = "<div class=\"configurations-json\">\r\n  <json-editor *ngIf=\"mode === modeCheck.DEFAULT\" [ngModel]=\"data.data\" jsonModal #staticModal=\"json-modal\"  [config]=\"{mode: 'view'}\" (change)=\"onChange($event)\">\r\n  </json-editor>\r\n  <json-editor *ngIf=\"mode === modeCheck.EDIT\" [ngModel]=\"data.data\" jsonModal #staticModal=\"json-modal\"  [config]=\"{mode: 'tree'}\" (change)=\"onChange($event)\">\r\n  </json-editor>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/configurations/configurations-json/configurations-json.component.html
// module id = ../../../../../src/app/configurations/configurations-json/configurations-json.component.html
// module chunks = main